<ng-template #panelHeader let-closeDataid="closeDataid">
    <ion-item class="header" color="warning" lines="none">
        <ion-label>{{ tr('@place_ticket_title') }}</ion-label>
        <ion-icon
            [uppDataid]="closeDataid"
            slot="end"
            name="close-outline"
            (click)="OnClose()"
        ></ion-icon>
    </ion-item>
</ng-template>

<ng-template #ticketPreview let-ticket="ticket">
    <upp-scrollable class="preview" [scrollbar]="'none'" [class.mobile]="view.Mobile">
        <upp-ticket-print [ticket]="ticket" [display]="true"></upp-ticket-print>
    </upp-scrollable>
</ng-template>

<ng-template #paymentbutton>
    <ion-button uppDataid="guestpay-show-button" class="paybutton"
        color="warning"
        size="large"
        expand="full"
        [disabled]="!CanProceedPay"
        (click)="OnShowPayment()">
        {{ tr('@place_ticket_payment') }}
    </ion-button>

    <div class="options" *ngIf="Selected.length > 0 || OnlineActive" [class.visible]="ShowPayment">
        <ion-item class="header" color="warning" lines="none">
            <ion-label>
                {{ tr('@place_ticket_payment_price') }}:
                <span class="price">{{ TotalPriceInfo.int }}<span class="decimal">,{{ TotalPriceInfo.dec }}</span>{{ tr('@currency') }}</span>
            </ion-label>
            <ion-icon *ngIf="!OnlineActive" uppDataid="guestpay-hide-button" slot="end" name="close-outline" (click)="OnHidePayment()"></ion-icon>
        </ion-item>

        <div class="options-body">
            <ng-container *ngIf="ShowInSiteOptions && !OnlineActive">
                <ion-label class="section-label">{{ tr('@place_ticket_payment_insite') }}</ion-label>
                <ion-item *ngIf="ShowCashOption" uppDataid="guestpay-cash-button" class="paybutton" lines="none" color="warning" (click)="OnPay('PAYCASH')">
                    <ion-icon slot="start" name="cash-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@place_ticket_pay_cash') }}<br/>
                        <span class="small">{{ tr('@place_ticket_paycash_message_ok') }}</span>
                    </ion-label>
                </ion-item>
                <ion-item *ngIf="ShowCardOption" uppDataid="guestpay-card-button" class="paybutton" lines="none" color="warning" (click)="OnPay('PAYCARD')">
                    <ion-icon slot="start" name="card-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@place_ticket_pay_card') }}<br/>
                        <span class="small">{{ tr('@place_ticket_paycard_message_ok') }}</span>
                    </ion-label>
                </ion-item>
                <ion-item *ngIf="ShowInvoiceOption" uppDataid="guestpay-waiter-button" class="paybutton" lines="none" color="warning" (click)="OnPay('PAYCASH')">
                    <ion-icon slot="start" name="person-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@place_call_waiter_message') }}<br/>
                        <span class="small">{{ tr('@place_ticket_waiter_message') }}</span>
                    </ion-label>
                </ion-item>
            </ng-container>

            <div *ngIf="ShowOnlineOption || OnlineActive" class="online-pay" uppDataid="guestpay-online">
                <ion-label class="section-label" *ngIf="!OnlineActive">{{ tr('@place_ticket_payment_online') }}</ion-label>
                <upp-payment-ticket
                    [tickets]="PayTickets"
                    [amount]="PayAmount"
                    [disabled]="!CanProceedPay || OnlineActive"
                    (ActiveChange)="OnOnlineActiveChange($event)">
                </upp-payment-ticket>
            </div>

            <p *ngIf="NoPaymentMethods" class="soon">{{ tr('@guest_panel_soon') }}</p>
        </div>

        <ion-button *ngIf="!OnlineActive" uppDataid="guestpay-cancel-button"
            color="warning"
            expand="block"
            fill="clear"
            (click)="OnHidePayment()">
            {{ tr('@place_ticket_pay_cancel') }}
        </ion-button>
    </div>
</ng-template>

<upp-guest-ticket-preview *ngIf="ShowTicket" uppDataid="guestpay-ticket-preview"
    [ticket]="ShowTicket"
    color="warning"
    (Done)="OnShowTicket(null)"
></upp-guest-ticket-preview>

<ng-container *ngIf="ShowTicket === null">
    <div class="ticket empty" *ngIf="Tickets.length === 0">
        <ng-container *ngTemplateOutlet="panelHeader; context: { closeDataid: 'guestpay-close-empty' }"></ng-container>
        <p>{{ tr('@place_ticket_payment_empty') }}</p>
        <ion-button uppDataid="guestpay-empty-close" color="warning" (click)="OnClose()">
            {{ tr('@guest_panel_back') }}
        </ion-button>
    </div>

    <ng-container *ngIf="ShowSinglePreview">
        <div class="ticket">
            <ng-container *ngTemplateOutlet="panelHeader; context: { closeDataid: 'guestpay-close-single' }"></ng-container>
            <ng-container *ngTemplateOutlet="ticketPreview; context: { ticket: Tickets[0] }"></ng-container>
            <div class="form-buttons">
                <ng-container [ngTemplateOutlet]="paymentbutton"></ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="ShowTicketList">
        <div class="ticket">
            <ng-container *ngTemplateOutlet="panelHeader; context: { closeDataid: 'guestpay-close-list' }"></ng-container>
            <upp-scrollable class="list" [scrollbar]="'none'" [class.mobile]="view.Mobile">
                <ion-item class="intro" lines="none">
                    <ion-label>
                        {{ Tickets.length === 1 ? tr('@place_ticket_payment_table_one') : tr('@place_ticket_payment_table_count', [Tickets.length]) }}<br/>
                        <span class="small">{{ tr('@place_ticket_payment_choose') }}</span>
                    </ion-label>
                </ion-item>
                <ion-list>
                    <div class="ticket-box" *ngFor="let ticket of Tickets; trackBy: TicketTrack" [ngClass]="{'selected': IsSelected(ticket), 'online-paying': IsPaymentPending(ticket)}">
                        <ion-item class="ticket-main" [uppDataid]="IsOnlinePaying(ticket) ? 'guestpay-online-wait' : (IsPaymentPending(ticket) ? 'guestpay-pending-wait' : null)"
                            lines="none"
                            [class.pending-wait-row]="IsPaymentPending(ticket)"
                            (click)="IsPaymentPending(ticket) && OnPendingTicketWait(ticket)">
                            <div slot="start" class="ticket-icon" [class.online-wait-icon]="IsPaymentPending(ticket)">
                                <ion-spinner *ngIf="IsPaymentPending(ticket)" name="crescent" class="pending-spinner"></ion-spinner>
                                <ng-container *ngIf="!IsPaymentPending(ticket)">
                                    <ion-icon name="receipt-outline"></ion-icon>
                                    <ion-icon class="ticket-pick"
                                        [name]="IsSelected(ticket) ? 'checkmark-circle' : 'close-circle'"
                                        [color]="IsSelected(ticket) ? 'success' : 'danger'">
                                    </ion-icon>
                                </ng-container>
                            </div>
                            <ion-label>
                                <span class="orderno" *ngIf="ticket.orderno">#{{ ticket.orderno }}</span>
                                <ng-container *ngIf="IsPaymentPending(ticket)">
                                    {{ tr('@place_event_type_PP') }}<br/>
                                    <span class="small">{{ tr('@pay_ticket_waiting_title') }}</span>
                                </ng-container>
                                <ng-container *ngIf="!IsPaymentPending(ticket)">
                                    {{ TicketElapsed(ticket) }}<br/>
                                    <span class="small">{{ ticket.InSession ? tr('@place_ticket_payment_from_this_phone') : tr('@place_ticket_payment_from_table') }}</span>
                                </ng-container>
                            </ion-label>
                            <ion-label class="price" slot="end" *ngIf="PriceParts(ticket.due || 0) as parts">
                                {{ parts.int }},<span class="small">{{ parts.dec }}</span>{{ tr('@currency') }}
                            </ion-label>
                        </ion-item>
                        <ion-item class="ticket-pay" lines="none" *ngIf="!IsPaymentPending(ticket)">
                            <ion-label>{{ tr('@place_ticket_payment_want_this') }}</ion-label>
                            <ion-toggle slot="end"
                                [checked]="IsSelected(ticket)"
                                (click)="$event.stopPropagation()"
                                (ionChange)="OnSelectChange(ticket, $event.detail.checked)">
                            </ion-toggle>
                        </ion-item>
                        <div class="ticket-receipt" uppDataid="guestpay-show-ticket" (click)="OnShowTicket(ticket)">
                            {{ tr('@place_ticket_payment_view_receipt') }}
                        </div>
                    </div>
                </ion-list>
                <ion-item uppDataid="guestpay-info-ticket" lines="none">
                    <ion-icon slot="start" name="information-circle-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@place_ticket_payment_total_price') }}<br/>
                        <span class="small">{{ tr('@place_ticket_payment_total_selected', [ Selected.length ]) }}</span>
                    </ion-label>
                    <ion-label slot="end" class="price">
                        {{ TotalPriceInfo.int }},<span class="small">{{ TotalPriceInfo.dec }}</span>{{ tr('@currency') }}
                    </ion-label>
                </ion-item>
            </upp-scrollable>
            <div class="form-buttons">
                <ng-container [ngTemplateOutlet]="paymentbutton"></ng-container>
            </div>
        </div>
    </ng-container>
</ng-container>

<upp-dialog *ngIf="PayCashTickets !== null"
    [backdropDismiss]="false"
    class="guestpay-dialog"
    (OnClose)="OnPayCashClose()">
    <upp-modal-cashpay
        [tickets]="PayCashTickets"
        (OnAccept)="OnPayCashAccept($event)"
        (OnClose)="OnPayCashClose()">
    </upp-modal-cashpay>
</upp-dialog>

<upp-dialog *ngIf="PayCardTickets !== null"
    [backdropDismiss]="false"
    class="guestpay-dialog"
    (OnClose)="OnPayCardClose()">
    <upp-modal-cardpay
        [tickets]="PayCardTickets"
        (OnAccept)="OnPayCardAccept()"
        (OnClose)="OnPayCardClose()">
    </upp-modal-cardpay>
</upp-dialog>
